<mat-toolbar color="primary" class="toolbar">
    <app-back-button [route]="['/home', 'perfil']" color="secondary"></app-back-button>
    <div>{{ "PRIVACY_POLICY.TITLE" | translate }}</div>
</mat-toolbar>

<mat-card class="mat-elevation-z0">
    <mat-card-content>
        <iframe [src]="privacyPolicy" class="privacy-policy-viewport"> </iframe>
    </mat-card-content>
</mat-card>
